'use client';
/**
 * LocaleToggle — toggle PT⇆ES para a landing pública.
 * Chama a Server Action set-locale existente.
 * Emite evento Locale Toggled (Landing) via trackLocaleToggled (AGR-2026-013).
 */
import * as React from 'react';
import { setLocaleAction } from '../_actions/set-locale';
import {
  trackLocaleToggled,
  type BaseLandingEventProps,
} from '@brisa/shared/observability/landing';

interface LocaleToggleProps extends BaseLandingEventProps {
  currentLocale: 'pt' | 'es';
  currentPath: string;
}

export function LocaleToggle({
  currentLocale,
  currentPath,
  user_id,
  session_id,
  feature_flag_active,
  feature_landing_planos_active,
}: LocaleToggleProps) {
  const [isPending, setIsPending] = React.useState(false);

  const toggle = async () => {
    const newLocale = currentLocale === 'pt' ? 'es' : 'pt';
    setIsPending(true);
    try {
      trackLocaleToggled(
        { from_locale: currentLocale, to_locale: newLocale, path: currentPath },
        { user_id, session_id, feature_flag_active, feature_landing_planos_active },
      );
      await setLocaleAction(newLocale, currentPath);
    } finally {
      setIsPending(false);
    }
  };

  return (
    <button
      onClick={toggle}
      disabled={isPending}
      aria-label={currentLocale === 'pt' ? 'Cambiar a español' : 'Mudar para português'}
      style={{
        background: 'none',
        border: '1px solid var(--brisa-text-dim, #557A5F)',
        color: 'var(--brisa-text, #DED0EA)',
        padding: '4px 10px',
        borderRadius: '4px',
        cursor: isPending ? 'wait' : 'pointer',
        fontSize: '0.75rem',
        fontFamily: 'var(--brisa-font-mono, monospace)',
        letterSpacing: '0.05em',
        opacity: isPending ? 0.7 : 1,
      }}
    >
      {currentLocale === 'pt' ? 'ES' : 'PT'}
    </button>
  );
}
